/**
 * Eingabe-Schema für Zuschlags-Staffeln (OPS-69). Spiegelt
 * `engine/ladders.ts`; die Engine-Invarianten (strikt aufsteigende Stufen)
 * prüft zusätzlich `validateLadder` beim Persistieren.
 */
import { z } from 'zod';
import { ENTGELT_GROUPS } from '../enums/index.js';
import { isoDateSchema } from './surcharge-rule-set.js';

export const surchargeLadderStepSchema = z
  .object({
    afterCompletedWeeks: z.number().int().min(0).max(520).optional(),
    afterCompletedMonths: z.number().int().min(0).max(120).optional(),
    percent: z.number().finite().min(0).max(1000),
  })
  .refine(
    (step) => (step.afterCompletedWeeks == null) !== (step.afterCompletedMonths == null),
    'Genau ein Auslöser pro Stufe: Wochen ODER Monate.',
  );

export const surchargeLadderCreateSchema = z.object({
  name: z.string().trim().min(1).max(120),
  base: z.enum(['wage', 'bill_rate']),
  /** Kundenspezifische Staffel (Preis-Staffel); fehlt = global (Referenz/Lohn). */
  clientId: z.string().uuid().optional(),
  /** EG-Block-Scope (TV-BZ-Blöcke, z. B. Chemie EG 1–2b); fehlt = alle EGs. */
  entgeltGroups: z.array(z.enum(ENTGELT_GROUPS)).min(1).optional(),
  validFrom: isoDateSchema,
  notes: z.string().trim().max(2000).optional(),
  steps: z.array(surchargeLadderStepSchema).min(1).max(30),
});

export type SurchargeLadderStepInput = z.infer<typeof surchargeLadderStepSchema>;
export type SurchargeLadderCreateInput = z.infer<typeof surchargeLadderCreateSchema>;
